import { useEffect } from 'react';

const countByClass: { [key: string]: number } = {};

function useCssClassToggleOnDocument(cssClass: string, isActive: boolean) {
    useEffect(() => {
        if (!isActive) return;

        countByClass[cssClass] = (countByClass[cssClass] || 0) + 1;

        document.body.classList.add(cssClass);

        return () => {
            let counter = countByClass[cssClass] || 0;

            if (counter === 0) return;

            countByClass[cssClass] = --counter;

            if (counter - 1 > 0) return;

            document.body.classList.remove(cssClass);
        };
    }, [cssClass, isActive]);
}

export default useCssClassToggleOnDocument;
